export default __webpack_public_path__ + "static/media/close.3ad82eb6.svg";